import { useApp, useCurrentRoute, useRouteBreadcrumb } from '@common/hooks';
import { AdminPage, Page } from '@hospital/components/layout';
import { useCreateUserStore, useCreateVeterinarianStore } from '@hospital/stores';
import { UserProfile } from '@hospital/views/shared/userprofile';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useOutlet } from 'react-router';

export const User = observer(() => {
    const { configuration } = useApp();
    const currentRoute = useCurrentRoute();
    const isRootRoute = currentRoute!.pathname.toLowerCase().indexOf('/myprofile') === 0;
    const isAdminRoute = currentRoute!.pathname.toLowerCase().indexOf('/admin') === 0;
    const store = useCreateUserStore(configuration, { recreateOnUserIdRoute: true });
    const vetStore = useCreateVeterinarianStore();
    const { setBreadCrumb } = useRouteBreadcrumb();
    const outlet = useOutlet();

    useEffect(() => {
        if (store.userId) {
            store.refreshUser(store.userId);
        }
    }, [store, store.userId]);

    useEffect(() => {
        if (store.user)
            setBreadCrumb(`${store.user.firstName} ${store.user.lastName}`);
        else
            setBreadCrumb(undefined);
    }, [store.user, setBreadCrumb]);

    const renderUser = () =>
        <Row className="g-0">
            {store.userLoading &&
                <Col md={12}>
                    <span> Loading user profile... </span>
                </Col>
            }
            {!store.userLoading &&
                <UserProfile store={store} vetStore={vetStore}></UserProfile>
            }
        </Row>;

    if (outlet) return <>{outlet}</>

    return (
        <>
            {
                isRootRoute && renderUser()
            }
            {
                isAdminRoute &&
                <AdminPage>
                    <Page.Content>
                        {renderUser()}
                    </Page.Content>
                </AdminPage>

            }
            {
                !isRootRoute && !isAdminRoute &&
                <Page>
                    <Page.Content>
                        {renderUser()}
                    </Page.Content>
                </Page>
            }
        </>
    )
});
